import { Menu, MenuItem, TextField, TextFieldProps } from "@material-ui/core";
import { FieldInputProps } from "formik";
import { get } from "lodash";
import * as React from "react";
import { NestedOption, Option } from "../../constants";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";
import { TemplateEnum } from "../../types/models";
import { nestedOptionsToString } from "../util/helpers";
import NestedMenuItem from "./NestedMenuItem";

type Props = TextFieldProps & {
    errorMessage?: string;
    field: FieldInputProps<string>;
    isTouched?: boolean;
    width?: string;
    options: Array<NestedOption<any> | Option<any>>;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
    onChange: (newValue: string) => void;
};

export const CustomCascadingMenu = ({
    style,
    label,
    type,
    autoComplete,
    required,
    errorMessage,
    field,
    disabled,
    isTouched,
    InputLabelProps,
    inputProps,
    children,
    onChange,
    onBlur,
    onClick,
    SelectProps,
    options,
    setFieldValue,
    ...props
}: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = !!anchorEl;

    const handleOpenMenu = (event: React.MouseEvent<any>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (value: string) => {
        setAnchorEl(null);
        setFieldValue(field.name, value);
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <>
            <div
                style={{
                    flexBasis: 0,
                    width: "100%",
                    flexGrow: 1,
                    ...style
                }}
            >
                <TextField
                    label={label}
                    value={nestedOptionsToString(options, field.value)}
                    name={field.name}
                    onBlur={(event: React.FocusEvent<any>) => {
                        field.onBlur(event);
                        if (onBlur) {
                            onBlur(event);
                        }
                    }}
                    onClick={(event: React.MouseEvent<any>) => {
                        handleOpenMenu(event);
                        if (onClick) {
                            onClick(event);
                        }
                    }}
                    InputLabelProps={InputLabelProps}
                    inputProps={inputProps}
                    InputProps={{
                        disableUnderline: true,
                        endAdornment: <img src={THEME.Images.icDropdown} alt="" />,
                        readOnly: true
                    }}
                    fullWidth
                    type={type}
                    disabled={disabled}
                    color="secondary"
                    aria-label={props["aria-label"]}
                    variant="filled"
                >
                    {children}
                </TextField>
            </div>
            <Menu
                open={open}
                onClose={() => {
                    handleClose();
                }}
                anchorEl={anchorEl}
            >
                {options.map((nestedMenu, index) => {
                    if (get(nestedMenu, "options")) {
                        return (
                            <NestedMenuItem label={t(nestedMenu.messageId)} key={index} parentMenuOpen={true}>
                                {get(nestedMenu, "options").map((option: Option<TemplateEnum>) => (
                                    <MenuItem
                                        onClick={() => {
                                            handleSelect(option.value);
                                        }}
                                        key={option.value}
                                    >
                                        {t(option.messageId)}
                                    </MenuItem>
                                ))}
                            </NestedMenuItem>
                        );
                    } else {
                        return (
                            <MenuItem
                                onClick={() => {
                                    handleSelect(get(nestedMenu, "value"));
                                }}
                                key={get(nestedMenu, "value")}
                            >
                                {t(nestedMenu.messageId)}
                            </MenuItem>
                        );
                    }
                })}
            </Menu>
        </>
    );
};
